import { Pipe, type PipeTransform } from '@angular/core';
import { PaymentAccountType } from '../enums/paymentaccounttype.enum';

@Pipe({
  name: 'patDisplayName',
  standalone: true,
})
export class PaymentAccountTypeDisplayNamePipe implements PipeTransform {
  transform(value: PaymentAccountType | undefined): string {
    if (value) {
      switch (value) {
        case PaymentAccountType.Banking:
          return 'Bank';
        default:
          return value;
      }
    } else {
      return '';
    }
  }
}
